module.exports = __webpack_public_path__ + "img/lumilive_5.debcb6f6.png";